import { useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

const AdsSuccess = () => {
  const [params] = useSearchParams();
  const orderNumber = params.get('order');
  const productName = params.get('product');

  useEffect(() => {
    fetch('/api/tracking', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event: 'ad_success', productName: productName || undefined }),
    }).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-offwhite flex flex-col">
      {/* Header */}
      <header className="bg-offblack py-4 text-center">
        <img
          src="/arme logo.png"
          alt="armé"
          className="w-20 h-20 mx-auto"
          style={{ filter: 'invert(1) grayscale(1) brightness(2)', mixBlendMode: 'screen' }}
        />
        <p className="text-warmgray-400 text-xs tracking-[0.3em] uppercase mt-1">Premium Jeans & Shoes</p>
      </header>

      {/* Content */}
      <div className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="max-w-md w-full text-center space-y-6">
          <div className="flex justify-center">
            <CheckCircleIcon className="w-20 h-20 text-green-500" />
          </div>

          <div>
            <h1 className="font-display text-display-sm text-offblack tracking-tight">
              Order Confirmed!
            </h1>
            <p className="text-warmgray-500 mt-2 text-sm">Your order has been placed successfully.</p>
          </div>

          {orderNumber && (
            <div className="bg-warmgray-100 border border-warmgray-200 px-6 py-4">
              <p className="text-xs uppercase tracking-widest text-warmgray-500 mb-1">Order Number</p>
              <p className="font-display text-2xl text-offblack">#{orderNumber}</p>
            </div>
          )}

          {productName && (
            <p className="text-sm text-warmgray-600">
              Your order for <strong className="text-offblack">{productName}</strong> has been received.
            </p>
          )}

          {/* Next steps */}
          <div className="bg-white border border-warmgray-200 px-6 py-5 text-left space-y-3">
            <p className="text-xs uppercase tracking-wider font-semibold text-offblack mb-3">What happens next</p>
            <ul className="text-sm text-warmgray-600 space-y-3">
              <li className="flex items-start gap-3">
                <span className="w-5 h-5 rounded-full bg-offblack text-offwhite text-xs font-bold flex items-center justify-center shrink-0 mt-0.5">1</span>
                <span>Our team will contact you shortly to confirm your order.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-5 h-5 rounded-full bg-offblack text-offwhite text-xs font-bold flex items-center justify-center shrink-0 mt-0.5">2</span>
                <span>Delivery within <strong className="text-offblack">2–5 business days</strong> across Algeria.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-5 h-5 rounded-full bg-offblack text-offwhite text-xs font-bold flex items-center justify-center shrink-0 mt-0.5">3</span>
                <span>Cash on Delivery — pay when you receive your order.</span>
              </li>
            </ul>
          </div>

          <Link
            to="/ads"
            className="inline-block w-full bg-offblack text-offwhite px-8 py-4 text-sm font-semibold tracking-[0.12em] uppercase hover:bg-charcoal transition-colors"
          >
            Order Another Product
          </Link>

          <Link
            to="/"
            className="block text-xs text-warmgray-400 hover:text-offblack transition-colors tracking-wide"
          >
            Visit our full store →
          </Link>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-offblack text-warmgray-400 text-center py-6 text-xs tracking-wide">
        <p>© {new Date().getFullYear()} armé — Premium Jeans & Shoes</p>
        <p className="mt-1 text-warmgray-600">Delivery across all Algeria · Cash on Delivery</p>
      </footer>
    </div>
  );
};

export default AdsSuccess;
